import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { UNKNOWN_WORDS_QUERY } from '../graphql/queries'
import { FETCH_UNKNOWN_WORDS } from '../redux/action-types'
import { cleanupUnknownWords } from '../redux/actions'

const useUnknownWordsQuery = (
  { menuCurationTaskId } = {},
  { sortBy } = {},
  { pageSize, currentPage } = {},
) => {
  const sessionId = useRef(nanoid())
  const dispatch = useDispatch()
  useCleanupRedux(cleanupUnknownWords)

  const { isLoading, error, data } = useSelector(
    store => store.unknownWords.unknownWords,
  )

  const refetch = useCallback(
    (filtersParam, sortersParam, paginationParam) => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_LOAD_UNKNOWN_WORDS
          .MENU_CURATOR_START_LOAD_UNKNOWN_WORDS,
        {
          menuCurationTaskId,
          sessionId: sessionId.current,
          eventCategory:
            ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_UNKNOWN_WORDS,
        },
      )

      apolloService.query({
        query: UNKNOWN_WORDS_QUERY,
        variables: {
          filters: filtersParam,
          sorters: sortersParam,
          pagination: paginationParam,
        },
        dispatch,
        onSuccess: () =>
          firebase.logEvent(
            ANALYTICS_EVENTS.MENU_CURATOR_LOAD_UNKNOWN_WORDS
              .MENU_CURATOR_END_LOAD_UNKNOWN_WORDS,
            {
              menuCurationTaskId,
              sessionId: sessionId.current,
              eventCategory:
                ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_UNKNOWN_WORDS,
            },
          ),
        action: FETCH_UNKNOWN_WORDS,
      })
    },
    [dispatch, menuCurationTaskId],
  )

  useEffect(() => {
    refetch(
      {
        menuCurationTaskId,
      },
      { sortBy },
      { pageSize, currentPage },
    )
  }, [refetch, menuCurationTaskId, sortBy, pageSize, currentPage])

  return { isLoading, error, data }
}

export default useUnknownWordsQuery
